import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import './viewprofile.scss'
import Logo from "../../images/logo.png";
import { WMSInput } from '../../widgets/input';
import { WMSDropdown } from '../../widgets/dropdown';
import { WMSSelect } from '../../widgets/selectbox';
import { apiUrl } from '../../base/utils';
import WHSLoader from '../../widgets/loader';
import { config } from '../../config';
import { toastError, toastSuccess } from '../../widgets/toaster';
import Check from "../../images/check.png";
import 'react-phone-number-input/style.css';
import { connect } from "react-redux";
import PhoneInput from 'react-phone-number-input';
import { invokeGetService, invokePostService } from '../../service';
import IntegraLogo from '../../images/integra-logo.png'
import { dispatchAuth } from '../../redux/action';
import HOCAutoLogout from '../autologout';

const roleFields = [
    { label: 'Role', placeHolder: 'Enter auther name', fieldName: 'role', value: '', fieldType: 'text', dataType: 'number', required: false, disabled: false, pattern: '', maxLength: '' },
]
const generalFields = [
    { label: 'Assign Journal', placeHolder: 'Select journal', fieldName: 'assignedjournal', value: '', fieldType: 'dropdown', dataType: 'number', required: true, disabled: false, pattern: '', maxLength: '' },
    { label: 'First Name', placeHolder: 'Enter first name', fieldName: 'firstname', value: '', fieldType: 'text', dataType: 'number', required: true, disabled: false, pattern: '/^[a-zA-Z]+$/', maxLength: '50' },
    // { label: 'Middle Name', placeHolder: 'Enter middle name', fieldName: 'middlename', value: '', fieldType: 'text', dataType: 'number', required: false, disabled: false, pattern: '/^[a-zA-Z]+$/', maxLength: '50' },
    { label: 'Last Name', placeHolder: 'Enter last name', fieldName: 'lastname', value: '', fieldType: 'text', dataType: 'number', required: true, disabled: false, pattern: '/^[a-zA-Z]+$/', maxLength: '50' },
]
const generalFieldsTwo = [
    { label: 'Phone', placeHolder: 'Enter contact no', fieldName: 'contactno', value: '', fieldType: 'selectNumber', dataType: 'number', required: false, disabled: false, pattern: '^[1-9][0-9]*$', maxLength: '10' },
    { label: 'Email', placeHolder: 'Enter email', fieldName: 'email', value: '', fieldType: 'text', dataType: 'number', required: true, disabled: false, pattern: '', maxLength: '250' },
]
const contactFields = [
    // { label: 'Job Title', placeHolder: 'Select job title', fieldName: 'jobtitle', value: '', fieldType: 'dropdown', dataType: 'number', required: false, disabled: false, pattern: '', maxLength: '' },
    { label: 'Institution Name', placeHolder: 'Enter institution name', fieldName: 'institution', value: '', fieldType: 'text', dataType: 'number', required: true, disabled: false, pattern: '', maxLength: '300' },
    { label: 'Department', placeHolder: 'Enter department', fieldName: 'department', value: '', fieldType: 'text', dataType: 'number', required: false, disabled: false, pattern: '', maxLength: '' },
    { label: 'Organization', placeHolder: 'Enter organization', fieldName: 'organization', value: '', fieldType: 'text', dataType: 'number', required: true, disabled: false, pattern: '', maxLength: '300' },
    { label: 'Country/Region', placeHolder: 'Select country', fieldName: 'country', value: '', fieldType: 'select', dataType: 'number', required: false, disabled: false, pattern: '', maxLength: '' },
]
function ViewProfile(props: any) {
    // const [rolegroup, setRolegroup] = useState<any>(roleFields);
    const [generalgroup, setGeneralgroup] = useState<any>(generalFields);
    const [generalgrouptwo, setGeneralgrouptwo] = useState<any>(generalFieldsTwo);
    const [contactgroup, setcontactgrouptwo] = useState<any>(contactFields);
    const [agree, setAgree] = useState(true);
    const [agreeCheck, setAgreeCheck] = useState(false);
    const [show, setShow] = useState(false)
    const [render, setrender] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [emailError, setemailError] = useState(null);
    const [contactnoError, setcontactnoError] = useState(null);
    const [isLoader, setIsLoader] = useState(false);
    const [emailStatus, setemailStatus] = useState<any>('');
    const [isModal, setIsModal] = useState(false);
    const [roles, setUserRole] = useState([])
    const [journals, setJournalOption] = useState([])
    const [modalContent, setModalContent] = useState('Successfully Registered');
    const [value, setValue] = useState();
    const [rolevalue, setRoleValue] = useState<any>('');
    const [roleid, setRoleId] = useState('');
    const [resetmodal, setResetModal] = useState(false);
    const [isPwd, setPwd] = useState(true)
    const [mailShow, setMailShow] = useState(false);
    const [isChanged, setChanges] = useState(false);
    const [popupmsg, setResetMsg] = useState('Are you sure want to reset the password?')
    const navigate = useNavigate();

    useEffect(() => {
        getUserRole('role')
        getOpationList('country');
        getJobTitleList('jobtitle')
        getDepartmentList('department');
        getJournalTitelList('journaltitle');
        getPropsData('userinfo')

    }, []);
    const getPropsData = async (type: any) => {
        let roleData: any = []
        props?.userInfo.roles.map((list: any) => roleData.push({ value: list.name, label: list.name, id: list.id }))
        setRoleValue(roleData)
        setRoleId(props?.userInfo.roles[0].roleid)
        console.log(props?.userInfo, "werew")
        const updatedfeild = generalgroup.map((list: any) => {
            if (list.fieldName == 'assignedjournal') {
                const data: { label: string; value: string; id: string }[] = [];
                if (props?.userInfo.roles[0].roleid == 3) {
                    (props?.userInfo?.reviewerjournal || []).forEach((list: any) => {
                        data.push({ label: list.code, value: list.code, id: list.journalid });
                    });
                } else {
                    (props?.userInfo?.editorjournal || []).forEach((list: any) => {
                        data.push({ label: list.code, value: list.code, id: list.journalid });
                    });
                }


                // Assuming you want to assign the 'data' array to the 'list.value'
                list.value = data;

            } else if (list.fieldName == 'firstname') {
                list.value = props?.userInfo?.firstname

            } else if (list.fieldName == 'lastname') {
                list.value = props?.userInfo?.lastname
            }
            return list
        })

        const generalTwo = generalgrouptwo.map((list: any) => {
            if (list.fieldName == 'contactno') {
                let contact = props.userInfo.contactno && props.userInfo.contactno.length > 0 ? props.userInfo.contactno.trim() : ''
                setValue(contact)
                // props?.userInfo?.contactno
            } else if (list.fieldName == 'email') {
                list.value = props?.userInfo?.email
            }
            return list
        })
        setGeneralgroup(updatedfeild)
        setGeneralgrouptwo(generalTwo)
    }

    const getJournalTitelList = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getJournalTitle;
            const response: any = await invokeGetService(url, {}, {}, props.isToken)
            if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
            const updatedfeild = generalgroup.map((list: any) => {
                if (list.fieldName == 'assignedjournal') {
                    let data: any = []
                    response.data.data.result.map((list: any) => {
                        data.push({ value: list.code, label: list.code, id: list.id })
                    })
                    list.options = data
                }
                return list
            })

            setGeneralgroup(updatedfeild)
        } catch (error) {
        }
    }

    const getUserRole = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getUserRoles;
            const response: any = await invokeGetService(url, {}, {}, props.isToken)
            if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
            let fileteredRole: any = response.data.data.result.filter((list: any) => list.value != 'Author')
            // const updatedfeild = generalgroup.map((list: any) => {
            //     if (list.fieldName == 'assignedjournal') {
            //         list.options = response.data.data.result
            //     }
            //     return list
            // })
            setUserRole(fileteredRole)
        } catch (error) {
        }
    }

    const getOpationList = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getCountry;
            // const response = await axios.get(`${config.prapp.basURL}${url}`);
            const response: any = await invokeGetService(url, {}, {}, props.isToken);
            if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);

            const updatedfeild = contactgroup.map((list: any) => {
                if (list.fieldName == 'country') {
                    list.options = response.data.data.result
                }
                return list
            })
            setcontactgrouptwo(updatedfeild);

        } catch (error) {
            toastError(`Get Country Options ${error}`)
        }
    }

    const checkEmailAvailability = async (evalue: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                let url = apiUrl.nodeApi.getEmailAvailability;
                const queryParams = { email: evalue }
                setIsLoader(true)
                const response: any = await invokeGetService(url, {}, queryParams, props.isToken)
                setIsLoader(false)
                // const response = await axios.get(`${config.prapp.basURL}${url}?email=${evalue}`);
                let emailstatus = ''
                if (!response.data.data.isSuccess) {
                    emailstatus = 'Email Id Not Registered'
                    setemailStatus(emailstatus)
                    resolve(false)
                } else {
                    setemailStatus('')
                    resolve(true)
                }
            } catch (error) {
                toastError(`Email availability status error ${error}`)
            }
        })
    }
    const getDepartmentList = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getDepartment;
            // const response = await axios.get(`${config.prapp.basURL}${url}`);
            const response: any = await invokeGetService(url, {}, {}, props.isToken);

            if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
            const updatedfeild = contactgroup.map((list: any) => {
                if (list.fieldName == 'department') {
                    list.options = response.data.data.result
                }
                return list
            })
            setcontactgrouptwo(updatedfeild);

        } catch (error) {
            toastError(`Get Department Options ${error}`)
        }
    }
    const getJobTitleList = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getJobtitle;
            const response: any = await invokeGetService(url, {}, {}, props.isToken);
            if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
            const updatedfeild = contactgroup.map((list: any) => {
                if (list.fieldName == 'jobtitle') {
                    list.options = response.data.data.result
                }
                return list
            })
            setcontactgrouptwo(updatedfeild);
        } catch (error) {
            toastError(`Get Jobtitle Options ${error}`)
        }
    }

    const handleFormChange = (e: any, item: any, i: any, field: string) => {
        const alphabeticRegex = /^[a-zA-Z]+$/;
        // let valid= e.target.value.length > 0 ? alphabeticRegex.test(e.target.value) : true
        // if(valid){
        if (field === "generalFields") {
            if (e.target.value.length > 0) {
                if (alphabeticRegex.test(e.target.value)) {
                    generalgroup[i].value = (e.target.value);
                    setGeneralgroup(generalgroup)
                    setrender(!render)
                }
            } else {
                generalgroup[i].value = (e.target.value);
                setGeneralgroup(generalgroup)
                setrender(!render)

            }
        } else if (field === 'generalFieldsTwo') {
            let value = '';
            if (item.fieldName == "contactno" && e !== '') {
                //  if(e && e.length <= 13){
                value = e
                setValue(e)
                //  }
            } else if (e.target.value[0] !== ' ' && item.fieldName == "email") {
                value = e.target.value
            }
            generalgrouptwo[i].value = value
            setGeneralgrouptwo(generalgrouptwo)
            setrender(!render)

        } else if (field === 'contactFields') {
            if (e.target.value.length > 0) {
                if (alphabeticRegex.test(e.target.value)) {
                    contactgroup[i].value = (e.target.value);
                    setcontactgrouptwo(contactgroup)
                    setrender(!render)
                }
            } else {
                contactgroup[i].value = (e.target.value);
                setcontactgrouptwo(contactgroup)
                setrender(!render)

            }
        }
        setemailStatus('')
        setSubmitted(false)

        // }
    }
    const handleFormSelection = (e: any, item: any, i: any, field: string) => {
        if (field === "generalFields") {
            if (e.target !== ' ') {
                generalgroup[i].value = (e.target);
                generalgroup[i].id = e.id
                if (generalgroup[i].fieldName == 'assignedjournal') {
                    // generalgroup[i].valueArray = e
                    generalgroup[i].value = e

                }

                setGeneralgroup(generalgroup)
                setrender(!render)
            }
        } else if (field === 'generalFieldsTwo') {
            if (e.target !== ' ') {
                generalgrouptwo[i].value = (e.target);
                generalgrouptwo[i].id = e.id

                setGeneralgrouptwo(generalgrouptwo)
                setrender(!render)
            }

        } else if (field === 'contactFields') {
            // if (item.fieldName == 'country') {
            if (e.target !== ' ') {
                contactgroup[i].value = (e.target);
                contactgroup[i].id = e.id
                setcontactgrouptwo(contactgroup)
                setrender(!render)
            }
        } else if (field === 'roles') {
            setRoleValue(e.target)
            setRoleId(e.id)

        }
    }
    const handleAgree = async () => {
        await comparePreviousValues()
        let evalue: any = generalgrouptwo.find((obj: any) => obj.fieldName === 'email')?.value
        let mailres: any = true
        if (evalue.length > 0 && /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(evalue)) {
            setemailStatus('')
            if (props?.userInfo?.email != evalue) {
                mailres = await checkEmailAvailability(evalue)
            }
            if (mailres) {
                setResetModal(true)
            }
        } else {
            let emailstatus = 'Enter correct format mail id'
            setemailStatus(emailstatus)
        }
        setrender(!render)
    }

    const comparePreviousValues = () => {
        return new Promise((resolve, reject) => {
            let assingn: any = []
            generalgroup.find((obj: any) => obj.fieldName == 'assignedjournal')?.value.forEach((list: any) => {
                assingn.push({ journalid: list.id, code: list.value });
            })
            const areArraysEqual = JSON.stringify(assingn) === JSON.stringify(props.userInfo.editorjournal);
            let isChanged = false;
            if (!areArraysEqual) {
                isChanged = true
            }
            generalgroup.map((list: any) => {
                if (list.fieldName == 'firstname' && list.value != props.userInfo.firstname) {
                    isChanged = true
                } else if (list.fieldName == 'lastname' && list.value != props.userInfo.lastname) {
                    isChanged = true
                }
            })
            generalgrouptwo.map((list: any) => {
                if (list.fieldName == 'email' && list.value != props.userInfo.email) {
                    isChanged = true
                }
                else if (list.fieldName == 'contactno' && value != props.userInfo.contactno.trim()) {
                    isChanged = true

                }
            })
            if (isChanged) {
                setResetMsg('Do you want to continue with updated changes?')
            } else {
                setResetMsg('Are you sure want to reset the password?')
            }

            setChanges(isChanged)
            setrender(!render)
            resolve(true);
        })

    }
    const handleClose = () => {
        setShow(!show)
    }
    const handleCheck = (e: any) => {
        setAgreeCheck(!agreeCheck);
        setAgree(!agree)
    }

    const setClearState = () => {
        generalgroup.map((list: any) => {
            list.value = ''
        })
        contactgroup.map((list: any) => {
            list.value = ''

        })
        generalgrouptwo.map((list: any) => {
            list.value = ''

        })
        setGeneralgroup(generalgroup)
        setGeneralgrouptwo(contactgroup)
        setcontactgrouptwo(generalgrouptwo)
    }


    const handleSave = async () => {
        // try {
        return new Promise(async (resolve, reject) => {
            try {
                setIsLoader(true)
                setSubmitted(true)
                let assingn: any = []
                generalgroup.find((obj: any) => obj.fieldName === 'assignedjournal')?.value.map((list: any) => {
                    assingn.push(list.id)
                })
                debugger;
                const payload = {
                    firstname: generalgroup.find((obj: any) => obj.fieldName === 'firstname')?.value,
                    lastname: generalgroup.find((obj: any) => obj.fieldName === 'lastname')?.value,
                    mappedJournal: assingn,
                    email: generalgrouptwo.find((obj: any) => obj.fieldName === 'email')?.value,
                    contactno: value,
                    roleid: roleid,
                }
                let generalgroupTest: any = true
                let generalgrouptwoTest: any = true

                generalgroup.forEach((list: any) => {
                    //assigned journal fields not appliccable for roleid 3 & 4
                    if (list.fieldName === 'assignedjournal' && (props?.userInfo.roles[0].roleid === 3 || props?.userInfo.roles[0].roleid === 4)) {
                        return;
                    }
                    if (list.required && (list.value === undefined || list.value === null || list.value === '' || (Array.isArray(list.value) && list.value.length === 0))) {
                        generalgroupTest = false;
                    }
                })

                generalgrouptwo.forEach((list: any) => {
                    if (list.required && (list.value === undefined || list.value === null || list.value === '' || (Array.isArray(list.value) && list.value.length === 0))) {
                        generalgrouptwoTest = false;
                    }
                })
                console.log("generalgroup", generalgroup);
                console.log("generalgrouptwo", generalgrouptwo);

                if (generalgroupTest && generalgrouptwoTest && !emailError && !emailStatus) {
                    let url = apiUrl.nodeApi.UserProfileUpdate;
                    const response: any = await invokePostService(url, payload, props.isToken)
                    setIsLoader(false)
                    if (!response.data.data.isSuccess) {
                        throw new Error(response.data.data.Error)
                    }
                    if (response.data.data.isSuccess) {
                        let assignJournal: any = [];
                        generalgroup.find((obj: any) => obj.fieldName === 'assignedjournal')?.value.map((list: any) => {
                            assignJournal.push({ journalid: list.id, code: list.value })
                        })
                        let result = {
                            firstname: generalgroup.find((obj: any) => obj.fieldName === 'firstname')?.value,
                            lastname: generalgroup.find((obj: any) => obj.fieldName === 'lastname')?.value,
                            middlename: props?.userInfo?.middlename,
                            honorificid: props?.userInfo?.honorificid,
                            assignedjournal: generalgroup.find((obj: any) => obj.fieldName === 'assignedjournal')?.value.find((list: any) => list.id),
                            email: generalgrouptwo.find((obj: any) => obj.fieldName === 'email')?.value,
                            contactno: value,
                            editorjournal: assignJournal,
                            jobtitleid: props?.userInfo?.jobtitleid,
                            institutionname: props?.userInfo?.institutionname,
                            departmentid: props?.userInfo?.departmentid,
                            organization: props?.userInfo?.organization,
                            countryid: props?.userInfo?.countryid,
                            roles: props?.userInfo?.roles,
                            token: props?.userInfo?.token,
                            userid: props?.userInfo?.userid
                        }
                        toastSuccess('Profile updated successfully')
                        props.dispatchAuth(true, props?.userInfo?.token, result);
                        resolve(true)
                        navigate("/manuscript");

                    }

                } else {
                    toastError('Please check mandatory fields')
                }

            } catch (error) {
                setResetModal(false)
                resolve(false)
                setIsLoader(false)
                toastError(error);

            }
        })

    }
    // const handleBlur = async (e: any, type: any) => {
    //     if (type == 'email') {
    //         if (e.target.value.length > 0 && /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(e.target.value)) {
    //             await checkEmailAvailability(e.target.value)
    //         } else {
    //             let emailstatus = 'Enter correct format mail id'
    //             setemailStatus(emailstatus)
    //         }
    //     }

    // };

    const closeModal = () => {
        setIsModal(false);
    };
    const sucessModal = () => {
        setClearState()
        navigate("/login")
        setShow(false)
    };
    const handleConfirm = (content: any) => {
        closeModal();
    };

    const cancelModal = () => {
        setClearState()
        navigate("/manuscript")
    }

    const handleCloseReset = () => {
        setResetModal(false)
    }
 const handleBack = () => {
        //clear the userData from the location state
        navigate("/manuscript");
    };
    const onlySentMail = async () => {
        let url = apiUrl.nodeApi.userForgotPassword;
        let evalue: any = generalgrouptwo.find((obj: any) => obj.fieldName === 'email')?.value
        const queryParams = { email: evalue }
        setIsLoader(true)
        const response: any = await invokeGetService(url, {}, queryParams, props.isToken)
        setIsLoader(false)
        if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
        if (response.data.data.isSuccess) {
            toastSuccess('Password reset link has been successfully sent to your mail address');
            navigate("/manuscript");

        }

    }

    const sucessResetModal = async () => {
        try {
            setResetModal(false)
            let url = apiUrl.nodeApi.userForgotPassword;
            let update: any = true
            if (isPwd) {
                update = await handleSave()
            }
            if (update) {
                let evalue: any = generalgrouptwo.find((obj: any) => obj.fieldName === 'email')?.value
                const queryParams = { email: evalue }
                setIsLoader(true)
                const response: any = await invokeGetService(url, {}, queryParams, props.isToken)
                setIsLoader(false)
                if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
                if (response.data.data.isSuccess) {
                    toastSuccess('Password reset link has been successfully sent to your mail address')
                }
            }

        } catch (error) {
            setIsLoader(false)
            toastError(error)
        }
    }
    const handlePasswordChange = () => {
        setPwd(!isPwd)
    }


    return (
        <div className="viewprofile mb-5">
            {isLoader && <WHSLoader></WHSLoader>}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Title></Modal.Title>
                <Modal.Body>
                    <div style={{ textAlign: 'center' }}>
                        <img src={Check} className='check' alt="logo" />
                        <h5>{modalContent}</h5>
                        <span style={{ fontSize: '13px' }}>Click on the link sent to your registered email ID to login</span>
                    </div>
                </Modal.Body>
                <Button variant="primary" onClick={sucessModal} title="OK" id="yes_btn">OK</Button>
            </Modal>
            <Modal show={resetmodal} onHide={handleCloseReset} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation Reset Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className='mb-3'>
                        <div className="row">
                            <div className="col-lg-12 ">
                                <WMSInput
                                    type="checkbox"
                                    name="actType"
                                    checked={isPwd}
                                    className=""
                                    onChange={(e: any) => handlePasswordChange()}
                                />
                                <span className="ml-2" style={{ fontSize: '14px' }}>{popupmsg}</span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="outline-secondary" onClick={handleCloseReset}>
                        CANCEL
                    </Button>
                    <Button onClick={sucessResetModal}>
                        OK
                    </Button> */}
                    {
                        isChanged ? (<Button onClick={sucessResetModal}>
                            YES
                        </Button>) : ''
                    }
                    {
                        !isChanged ? (<Button onClick={onlySentMail}>
                            YES
                        </Button>) : (
                            <Button onClick={onlySentMail}>
                                NO
                            </Button>
                        )
                    }
                    <Button variant="outline-secondary" onClick={handleCloseReset}>
                        CANCEL
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="page-title">
                <div className='d-flex'>
                    <Button
                        onClick={handleBack}
                        className="iconBtn"
                        title="Back"
                        style={{ padding: "0px" }}
                    >
                        <span className="material-icons">chevron_left</span>
                    </Button>
                    <h3>My Profile</h3>

                </div>
            </div>
            <div className='register-body' style={{ marginBottom: '20px' }}>
                <div className='row'>
                    <div className='col-lg-3 col-md-12 col-sm-12 form-group'>
                        <label>Role</label>
                        <WMSSelect
                            className="form-control"
                            placeHolder={'Select Role'}
                            options={roles}
                            name="fileTypes"
                            value={rolevalue}
                            isMulti={false}
                            disabled={true}
                            onChange={(e: any) => handleFormSelection(e, 'role', 'role', "roles")}
                            id="fileTypes"
                        />
                    </div>

                </div>
                <div className='row'>
                    {generalgroup.map((form: any, i: any) =>
                        <>
                            {(form.fieldType === 'dropdown' && form.fieldName === 'assignedjournal') && props?.userInfo.roles[0].roleid !== 3 && props?.userInfo.roles[0].roleid !== 4 &&
                                <div className='col-lg-12 col-md-12 col-sm-12 form-group'>
                                    <div className='row'>
                                        <div className='col-lg-3'>
                                            <label>{form.label}
                                                {form.required && <span className='text-danger'>*</span>} </label>
                                            <WMSSelect
                                                className="form-control"
                                                placeHolder={form.placeHolder}
                                                options={form.options}
                                                name="fileTypes"
                                                value={form.value}
                                                isMulti={true}
                                                onChange={(e: any) => handleFormSelection(e, form, generalgroup.findIndex((data: any) => data.fieldName === form.fieldName), "generalFields")}
                                                id="fileTypes"
                                            />
                                            {submitted && form.required && !form.value ? <span className='error'>{form.label} is required</span> : null}
                                        </div>
                                    </div>
                                </div>
                            }
                            {(form.fieldType === 'text' && form.fieldName !== 'email' && form.fieldName !== 'contactno') && <div className='col-lg-3 col-md-12 col-sm-12 form-group'>
                                <label>{form.label}  {form.required && <span className='error'>*</span>}</label>
                                <WMSInput type='text' placeHolder={form.placeHolder} className='form-control' value={form.value} disabled={form.disabled}
                                    maxLength={form.maxLength} onChange={(e: any) => handleFormChange(e, form, generalgroup.findIndex((data: any) => data.fieldName === form.fieldName), 'generalFields')} id={form.fieldName} />
                                {submitted && form.required && !form.value ? <span className='error'>{form.label} is required</span> : null}
                                {submitted && form.required && form.value.length == 0 && form.fieldName == 'assignedjournal' ? <span className='error'>{form.label} is required</span> : null}

                            </div>
                            }
                        </>
                    )}
                </div>

                <div className='row'>
                    {generalgrouptwo.map((form: any, i: any) =>
                        <>
                            {form.fieldType === 'text' && <div className='col-lg-3 col-md-12 col-sm-12 form-group'>
                                <label>{form.label}  {form.required && <span className='error'>*</span>}
                                    {form.fieldName === 'email' ? <span className="material-icons file-note" onClick={() => setMailShow(!mailShow)}>
                                        info
                                    </span>
                                        : ''}</label>
                                {mailShow ? <div className='email-tip'>
                                    <p>We will be sent a confirmation email with a link to click on. Using the link in the confirmation email will enable you to sign up for email alerts.</p>
                                </div> : ''}
                                <WMSInput type='text' placeHolder={form.placeHolder} value={form.value} className='form-control'
                                    disabled={form.disabled || (form.fieldName === 'email')}
                                    maxLength={form.maxLength} onChange={(e: any) => handleFormChange(e, form, generalgrouptwo.findIndex((data: any) => data.fieldName === form.fieldName), 'generalFieldsTwo')} id={form.fieldName} />
                                {submitted && form.required && !form.value ? <span className='error'>{form.label} is required</span> : null}
                                {submitted && form.value && form.fieldName == 'email' ? <span className="error">{emailError}</span> : null}
                                {form.value && form.fieldName == 'email' ? <span className="error">{emailStatus}</span> : null}
                                {submitted && form.value && form.fieldName == 'contactno' ? <span className="error">{contactnoError}</span> : null}
                            </div>
                            }
                            {form.fieldType === 'selectNumber' && props?.userInfo.roles[0].roleid !== 3 && props?.userInfo.roles[0].roleid !== 4 && <div className='col-lg-3 col-md-12 col-sm-12 form-group'>
                                <label>{form.label}  {form.required && <span className='error'>*</span>}</label>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    value={value}
                                    initialValueFormat="national"
                                    onChange={(e: any) => handleFormChange(e, form, generalgrouptwo.findIndex((data: any) => data.fieldName === form.fieldName), 'generalFieldsTwo')} />
                            </div>
                            }
                        </>
                    )}
                    {/* <Button disabled={generalgrouptwo.find((list: any) => list.fieldName == 'email')?.value.length == 0} onClick={handleAgree} className='link-btn'>Reset Password</Button> */}

                </div>
            </div>
            <Button onClick={handleSave}>UPDATE</Button>
            <Button className='ml-3' variant="outline-secondary" onClick={() => cancelModal()}>CANCEL</Button>
        </div>
    )
}
const mapStateToProps = (state: any) => {
    return {
        isLogged: state.rootReducer.authReducer.isLoggedIn,
        isToken: state.rootReducer.authReducer.token,
        userInfo: state.rootReducer.authReducer.userInfo

        // isFileUpload:state.rootReducer.articleReducer.fileUpload
    }
}

// const mapDispatchToProps = (dispatch: any) => {
//     return {
//         dispatchFileUpload: (fileUploaddata: any) => {
//             dispatchFileUpload(dispatch, fileUploaddata);
//         },
//         dispatchStepAction: (stepCounter: any) => {
//             dispatchStepAction(dispatch, stepCounter)
//         }
//     }
// }
const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAuth: (isLogged: any, userData: any, userInfo: any) => {
            dispatchAuth(dispatch, isLogged, userData, userInfo);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HOCAutoLogout(ViewProfile));
